/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\MERCEDES.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:16:24 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function MERCEDES(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M551.59,267.06c-165.36,0-299.42,134.06-299.42,299.42s134.06,299.42,299.42,299.42,299.42-134.06,299.42-299.42-134.05-299.42-299.42-299.42Zm-245.08,158.67c49.92-86.58,141.96-140.4,241.8-141.7l-38.74,256.61h0s0,0,0,0h0l-204.61,165.36c-49.14-87.1-48.62-193.7,1.56-280.27Zm246.2,424.66c-100.1,.52-192.91-52-244.13-138.06l243.1-100.62,244.13,99.06c-50.7,86.32-143.26,139.36-243.1,139.62Zm39.78-306.33l-36.92-260c99.47,1.52,190.86,55.11,240.76,141.18,50.17,86.06,51.22,191.88,3.11,278.97l-206.95-160.15Z"/>
        </svg>
    );
}

export default MERCEDES;
